export const non_disclosure_agreement= {
    templateId: 214,
    category: 13,
    templateTitle: 'Non-disclosure Agreement',
    templateDescription: `<p></p>`,
    description: `
  
  `,

    sides: [
        {
            signature: 'Seller:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Name of business entity",
              },
              {
                type: "input",
                required: true,
                placeholder: "Street and street number",
              },
              {
                type: "input",
                required: true,
                placeholder: "Place",
              },
              {
                type: "input",
                required: true,
                placeholder: "State",
              },
              {
                type: "input",
                placeholder: "Registered court number",
                inSignature: true,
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Represented by",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Function",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Seller)',
            delimiter: `i`
        },
        {
            signature: 'Buyer:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Name of business entity",
              },
              {
                type: "input",
                required: true,
                placeholder: "Street and street number",
              },
              {
                type: "input",
                required: true,
                placeholder: "Place",
              },
              {
                type: "input",
                placeholder: "Registered court number",
                inSignature: true,
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Represented by",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Function",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Buyer),'
        }
    ],

    headline: 'have concluded following',
    title: 'AGREEMENT FOR SALE OF GOODS',
    noArticleNumbers: true,

    articles: [

        {
            title: 'SUBJECT OF SALE',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'The Subject of this Agreement is sale of:'},
                        {type: 'textarea', value: '', required: true, help: 'Ovdje pobliže opisujete predmet kupoprodaje.'},
                        {type: 'text', content: '(hereinafter: Goods).'},],
                  
                    }],
        }, 
        {
            title: 'QUANTITY',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'SELLER desires to sell and BUYER desires to buy these goods in quantity of'},
                        {type: 'input', value: '', required: true, help: 'Potrebno je upisati količinu.'},
                        {type: 'text', content: ','},
                        {type: 'input', value: '', required: true, help: 'Potrebno je upisati mjernu jedinicu.'},
    ],
                }],
        },
        {
            title: 'QUALITY',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Quality of goods is'},
                        {type: 'textarea', value: '', required: true, help: 'Upisati kvalitetu predmeta kupoprodaje.'},],
                    }],
        },
        {
            title: 'PRICE',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Contractual parties agree that the price of Goods is:',
                    help: 'Potrebno je upisati cijenu.',
                    value: '',
                }],
        },
        {
            title: 'PAYMENT',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'BUYER shall make payment to SELLER for Goods as specified in Annex Pro Forma Invoice no. 006 as follows:'},
                                {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja. Prethodno pogledati uvodni tekst prije dokumenta.'},
                                {type: 'text', content: 'dana od dana isporuke.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Kupac je dužan platiti cijenu Prodavatelju za Predmet kupoprodaje u roku od '},
                                {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja. Prethodno pogledati uvodni tekst prije dokumenta.'},
                                {type: 'text', content: 'dana od primitka računa.'}]
                        },
                {
                    parts: [
                      { type: "text", content: "Kupac je dužan platiti cijenu Prodavatelju za Predmet kupoprodaje u sljedećim rokovima:" },
                      { type: "textarea", value: "", required: true },
                      { help: 'Upisati rokove plaćanja. Prethodno pogledati uvodni tekst gore.'}
                    ]
                  }
                ],
                value: "",
              },
            ]
          },
          {
            title: 'DELIVERY PLACE',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Goods shall be delivered'},
                        {type: 'input', value: '', required: true, help: 'Upisati mjesto isporuke.'},
                        {type: 'text', content: 'on parity'},
                        {type: 'input', value: '', required: true, help: 'Upisati paritet. Prethodno pogledati uvodni tekst gore.'},
           ],
                }],
        },
        {
            title: 'DELIVERY PLACE',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Goods shall be delivered'},
                        {type: 'input', value: '', required: true, help: 'Upisati mjesto isporuke.'},
                        {type: 'text', content: 'on parity'},
                        {type: 'input', value: '', required: true, help: 'Upisati paritet. Prethodno pogledati uvodni tekst gore.'},
           ],
                }],
        },
        {
            title: 'DELIVERY TIME',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'The Goods shall be delivered on:'},
                                {type: 'input', value: '', required: true, help: 'Upisati trenutak isporuke predmeta kupoprodaje.'},
                              ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'The Goods shall be delivered no later than:'},
                                {type: 'input', value: '', required: true, help: 'Upisati krajnji rok isporuke.'},
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'The Goods shall be delivered in term of'},
                                {type: 'input', value: '', required: true, help: 'Upisati rok isporuke.'},
                                {type: 'text', content: 'from'},
                                {type: 'input', value: '', required: true, help: 'Prethodno u ovoj rečenici upisati rok, a onda ovdje i događaj od kojega se računa rok isporuke.'},
            ]
                        }],
                    value: '',
                }
            ]
        },  
        {
            title: 'NEDOSTACI',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'Kupac će pregledati Predmet kupoprodaje prilikom preuzimanja te je na vidljive nedostatke dužan prigovoriti u roku'
                        },
                        {type: 'input', value: '', required: true, help: 'Upisati rok.'},
                        {type: 'text', content: ', a na skrivene nedostatke u roku od'},
                        {type: 'input', value: '', required: true, help: 'Upisati rok.'},
        ],
                }],
        },
        {
            title: 'OTKAZ UGOVORA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Svaka ugovorna strana može jednostrano, pisanim putem, bez navođenja razloga, otkazati ovaj Ugovor pisanim putem uz otkazni rok od'
                        },
                        {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                        {type: 'text', content: 'dana, a koji počinje teći od trenutka dostave otkaza drugoj ugovornoj strani.'},
                                    {type: 'text', content: 'Učinci takvog prestanka ugovora uslijed otkaza su sljedeći:', help: 'Učinke otkaza možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'},
                                    { type: "textarea", value: "", required: true },
                                    { help: 'Ovdje definirate učinke prestanka ugovora uslijed otkaza.',}],
                }],
        },
        {
            title: 'RASKID UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text', content: 'U slučaju da jedna ugovorna strana krši obveze iz ovog Ugovora, druga strana može pisanim putem jednostrano raskinuti ugovor uz otkazni rok od' },
                                    {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                                    {type: 'text', content: ', a koji počinje teći od trenutka dostave raskida drugoj ugovornoj strani.'},
                                    {type: 'text', content: 'Posljedice takvog raskida su sljedeće:'},
                                    { type: "textarea", value: "", required: true },
                                    { help: 'Učinke raskida možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'}
                    ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'U slučaju da Kupac ne podmiri Prodavatatelju kupoprodajni iznos u cijelosti do dana:'},
                                {type: 'input', value: '', required: true, help: 'Upisati datum.'},
                                {type: 'text', content: ', ovaj ugovor se automatski raskida sa sljedećim učincima:'},
                                { type: "textarea", value: "", required: true },
                                { help: 'Učinke raskida možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'},
         ]
                        }],
                }
            ]
        },
     
        {
            title: 'DURATION OF AGREEMENT',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'This Agreement is concluded only for sale of Goods specified in this Agreement and it ends with proper execution of mutual obligations according to this Agreement.'
                                }]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'This Agreement is concluded in exact term and starts from'},
                                {type: 'input', value: '', required: true, help: 'Upišite datum početka Ugovora.'},
                                {type: 'text', content: 'and ends on'},
                                {type: 'input', value: '', required: true, help: 'Upišite datum završetka Ugovora. '},
             ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'APPLICABLE LAW AND LEGAL PROCEEDINGS',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'This Agreement is governed by and construed in accordance with the Laws of Republic of Macedonia. Any disputes arising out of this Agreement shall be settled in an amicable way. In case Parties fail to settle their conflict/s amicably, all disputes, controversies or claims arising out or relating to this Agreement will be resolved exclusively and finally by Macedonian chamber of Commerce arbitration in accordance with the its rules. The language to be used in the arbitration will be the English language, if possible. This Agreement will enter into force and implementation after being signed by both parties.',
                    value: '',
                }],
        },
        {
            title: 'COPIES OF AGREEMENT',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'This Agreement is made in'
                        },
                        {type: 'input', value: '', required: true, help: 'Upišite broj primjeraka.'},
                        {type: 'text', content: '​identical copies​'},
                        {type: 'input', value: '', required: true, help: 'Upišite broj primjeraka.'},
                        {type: 'text', content: '​for each Party.'}],
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/214_non_disclosure_agreement.ts